import React, { useState } from 'react';
import { DateRange, TimeframeType } from '../types';
import { format } from 'date-fns';
import { Calendar, RefreshCw } from 'lucide-react';
import DateRangePicker from './DateRangePicker';
interface HeaderProps {
  dateRange: DateRange;
  onDateRangeChange: (dateRange: DateRange) => void;
}
const Header: React.FC<HeaderProps> = ({
  dateRange,
  onDateRangeChange
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const handleDateSelect = ({
    currentStartDate,
    currentEndDate,
    previousStartDate,
    previousEndDate
  }: {
    currentStartDate: Date;
    currentEndDate: Date;
    previousStartDate: Date;
    previousEndDate: Date;
  }) => {
    onDateRangeChange({
      type: 'custom',
      startDate: currentStartDate,
      endDate: currentEndDate
    });
  };
  return <header className="bg-background border-b" data-id="element-78">
      <div className="container py-4 flex justify-between items-center" data-id="element-79">
        <h1 className="text-2xl font-semibold" data-id="element-80">
          Product Ops Throughput
        </h1>
        <div className="flex items-center gap-2" data-id="element-81">
          <div className="relative" data-id="element-82">
            <button onClick={() => setIsOpen(!isOpen)} className="flex items-center gap-2 px-4 py-2 text-sm bg-white border rounded-lg hover:bg-gray-50" data-id="element-83">
              <Calendar className="w-4 h-4" data-id="element-84" />
              <span data-id="element-85">
                {format(dateRange.startDate, 'MMM d, yyyy')} -{' '}
                {format(dateRange.endDate, 'MMM d, yyyy')}
              </span>
            </button>
            {isOpen && <div className="absolute right-0 mt-2 z-10" data-id="element-86">
                <DateRangePicker onSelect={handleDateSelect} onClose={() => setIsOpen(false)} data-id="element-87" />
              </div>}
          </div>
          <button className="p-2 text-gray-600 hover:text-gray-900 hover:bg-gray-100 rounded-lg" onClick={() => {
          const now = new Date();
          handleDateSelect({
            currentStartDate: dateRange.startDate,
            currentEndDate: dateRange.endDate,
            previousStartDate: new Date(dateRange.startDate.getTime() - (dateRange.endDate.getTime() - dateRange.startDate.getTime())),
            previousEndDate: new Date(dateRange.endDate.getTime() - (dateRange.endDate.getTime() - dateRange.startDate.getTime()))
          });
        }} data-id="element-88">
            <RefreshCw className="w-4 h-4" data-id="element-89" />
          </button>
        </div>
      </div>
    </header>;
};
export default Header;